import apiUrl from '../../../helpers/apiUrl';
import axios, { AxiosResponse } from 'axios';
import RoutesIndexes from 'modules/authModule/enums/RoutesIndexes';
import { message } from 'antd';
import moment from 'moment';

const getAllCategoriesRequest = async (): Promise<{
  code: number;
  message: string;
  error?: number;
  data?: any;
} | void> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/all-categories`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(
      (
        response:
          | AxiosResponse<{ code: number; message: string }>
          | { data: { code: number; message: string } }
      ) => {
        if (response.data.code === RoutesIndexes.WRONG_USERNAME_OR_PASSWORD) {
          message.error(response.data.message);
        }
        if (response?.data) {
          return response.data;
        }
      }
    )
    .catch((e) => {
      message.error(e.message);
    });
};

const getSpecificAllCategoryRequest = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/all-categories/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const removeSpecificNewsRequest = async (idNews: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/news/${idNews}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const removeSpecificAllCategoryRequest = async (id: number): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/all-categories/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      return true;
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

const createNewsRequest = async (data: {
  id?: number;
  dateAdd: moment.MomentInput;
  name: string;
  intro: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/news`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: any) => {
      if (response.data?.error === 'DUPLICATE') {
        message.error('Wpis o danym tytule już istnieje');
      } else {
        message.success('Pozytywnie utworzono newsa');
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

const createAllCategoryRequest = async (data: {
  isActive?: boolean;
  name: string;
}): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/all-categories`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      message.success('Pozytywnie utworzono kategorię');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};


const saveAllCategoryRequest = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/all-categories/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export {
  removeSpecificNewsRequest,
  createNewsRequest,
  removeSpecificAllCategoryRequest,
  getSpecificAllCategoryRequest,
  createAllCategoryRequest,
  saveAllCategoryRequest,
  getAllCategoriesRequest,
};
